import { h,render } from 'preact';
import copy from 'copy-to-clipboard';
import { Context } from './context';
import CiblerAPI from './ciblerApi';
import Banner from './block/banner';
import Notification from './block/notification';
import Popup from './block/popup';
import PopupCustom from './block/popupcustom';
import PopupMail from './block/popupmail';
import ComplexInline from './block/complexInline';
import ScrollingInlineDiv from './block/scrollingInlineDiv';
import NotifV2 from './block/notifv2';
import NotifV3 from './block/notifv3';
import Pannel from './block/pannel';
import Button from './block/button';
import Utils from '../utils';
import { insertCustomComponents, replaceParameters, contextCondition } from './block/common';
import Form from "./block/form";
import PopupV2 from "./block/popupV2";
import PopupV3 from "./block/popupV3";

export default class InlineCommands {
  static inject = (gameUrl, props, callback) => {
    if (document.querySelector(`#WioGameBG_${props.campaignId}`))
      return;

    contextCondition(props, (condition) => {
      if (!condition) {
        callback(false);
        return;
      }

      this.addCSS(`${window.WIOCONFIG.renderUrl}wiorender.css`);

      const format = Utils.getCampaignData(props.campaigndata?.format, 'banner');

      let confirm = true;
      switch (format) {
        case 'iframe':
          Utils.tryFunction(this.insertIframeComponent, [props, gameUrl]);
          break;
        case 'inlineDiv':
          confirm = Utils.tryFunction(this.insertInlineContent, [props], false);
          break;
        case 'customRender':
          Utils.tryFunction(this.customRender, [props, callback]);
          return;
        default:
          confirm = Utils.tryFunction(this.insertReactComponent, [props, format, gameUrl], false);
      }

      callback(confirm);
    });
  };

  static replaceBlock = (doc, div, conf) => {
    const docClone = doc.cloneNode(true);
    docClone.innerHTML = '';
    docClone.appendChild(div);
    doc.parentNode.replaceChild(docClone, doc);
    docClone.style.cursor = 'initial';
    if (conf.style) {
      Object.keys(conf.style).forEach((k) => {
        docClone.style[k] = conf.style[k];
      })
    }
  };

  static insertBlock = (conf, doc, div) => {
    if (conf.childStyle) {
      Object.keys(conf.childStyle).forEach((k) => {
        div.style[k] = conf.childStyle[k];
      });
    }

    if (conf.replace) this.replaceBlock(doc, div, conf);
    else {
      if (conf.first) doc.insertBefore(div, doc.firstChild);
      else doc.appendChild(div);

      if (conf.style) {
        Object.keys(conf.style).forEach((k) => {
          doc.style[k] = conf.style[k];
        });
      }
    }
  }

  static insertInlineBlock = (props, div) => {
    const defaultId = '#cibler_inline_div';
    const inlineId = Utils.getCampaignData(props.campaigndata.inlineId, defaultId);
    if (Utils.isStringJson(inlineId)) {
      const inline = JSON.parse(inlineId);
      if (inline.length) {
        for (let i = 0; i < inline.length; i += 1) {
          const doc = document.querySelector(inline[i].id);
          if (doc) {
            this.insertBlock(inline[i], doc, div);
            return inline[i];
          }
        }

        const doc = document.querySelector(defaultId);
        if (doc) {
          this.insertBlock(inline[0], doc, div);
          return inline[0];
        }
      }
    } else {
      const doc = document.querySelector(inlineId);
      if (doc) {
        doc.appendChild(div);
        return { id: inlineId };
      } else if (document.querySelector(defaultId)) {
        document.querySelector(defaultId).appendChild(div);
        return { id: defaultId };
      }
    }

    return null;
  };

  static insertInlineContent = (props) => {
    const content = Utils.tryFunction(replaceParameters, [props.campaigndata.content.value, props]);
    if (!content) return false;

    const div = document.createElement('div');
    div.id = `WioGameBG_${props.campaignId}`;
    div.innerHTML = content;
    div.style.opacity = 0;
    const inlineConf = this.insertInlineBlock(props, div);

    if (!inlineConf) return false;

    setTimeout(() => {
      const height = div.scrollHeight;
      if (inlineConf.disableAnimation) {
        div.style.height = 0;
        setTimeout(() => {
          div.style.opacity = 1;
          div.style.transition = 'height linear 500ms';
          div.style.height = `${height}px`;
        }, 100);
      } else {
        div.style.opacity = 1;
      }
      if (inlineConf.resizeParent) {
        const parentStyle = window.getComputedStyle(div.parentElement);
        div.parentElement.style.height = `${parseInt(parentStyle.height) + height}px`;
      }
    }, 200);

    const context = Context[props.campaignId];
    window.WIO.track('showOperation', props.campaignId, context.sessionId);

    Utils.tryFunction(insertCustomComponents, [props]);
    const acceptButton = div.querySelector('#wioBlockAccept');
    if (acceptButton) {
      acceptButton.onclick = props.acceptBlock;
    }
    const crossSellButton = div.getElementsByClassName('wioBlockCrossSell');
    if (crossSellButton.length) {
      crossSellButton[0].onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        window.WIO.track('acceptBlock', props.campaignId, context.sessionId);
        window.WIO.track('discoverBlock', props.campaignId, context.sessionId);
          props.crossSellCustomAction(
            context.crossSell.id,
            null,
            () => {crossSellButton[0].parentElement.innerHTML = '';}
          );
        return false;
      };

      return;
    }

    const autoCloseTimeout = Utils.getCampaignData(props.campaigndata.autoCloseTimeout, 0);
    if (autoCloseTimeout) {
      setTimeout(() => {
        div.parentNode.removeChild(div);
      }, autoCloseTimeout);
    }
    if (inlineConf && inlineConf.sticky) {
      this.staySticky(div, inlineConf.sticky);
    }

    return true;
  };

  static staySticky = (el, conf) => {
    const elTopRef = el.getBoundingClientRect().top + window.scrollY;
    let lastScroll = 0;
    document.addEventListener('scroll', () => {
      if (window.scrollY < elTopRef) {
        el.classList.remove('wioSticky');
        el.parentElement.style.zIndex = '';
        return;
      }

      if (!el.classList.value.includes('wioSticky')) el.classList.add('wioSticky');
      el.parentElement.style.zIndex = 'initial';
      if (window.scrollY < (conf.trigger || 500)) return;
      if (lastScroll < window.scrollY) {
        el.style.top = conf.position || '-80px';
      } else {
        el.style.top = '';
      }

      lastScroll = window.scrollY;
    });
  };

  static insertReactComponent = (props, format, gameUrl) => {
    const tags = {
      banner: Banner,
      notification: Notification,
      notifV2: NotifV2,
      notifV3: NotifV3,
      popup: Popup,
      popupcustom: PopupCustom,
      popupmail: PopupMail,
      complexInline: ComplexInline,
      scrollingInlineDiv: ScrollingInlineDiv,
      pannel: Pannel,
      button: Button,
      form: Form,
      popupV2: PopupV2,
      popupV3: PopupV3,
    };

    const localFormat = format === 'popup' && Utils.getCampaignData(props.campaigndata.customContent, false)
      ? 'popupcustom'
      : format;

    const Block = tags[localFormat];

    const div = document.createElement('div');
    div.id = `WioGameBG_${props.campaignId}`;
    div.classList.add('WioGameBG');

    let inlineConfig = null;
    if (Utils.getCampaignData(props.campaigndata?.inlineId, '')) {
      inlineConfig = this.insertInlineBlock(props, div);

      if (!inlineConfig) return false;
    } else {
      if (!document.getElementsByTagName('body') || !document.getElementsByTagName('body').length) return false;
      document.getElementsByTagName('body')[0].append(div);
    }

    if (Utils.getDevice() === 'desktop' && window.WIOCONFIG.customerId === 60) {
      this.staySticky(div);
    }

    render(
      (
        <div id={`wio_container_${props.campaignId}`} style={{ opacity: 0 }}>
          <Block
            {...props.campaigndata}
            {...props}
            gameUrl={gameUrl}
          />
        </div>
      ),
      div,
    );
    div.children[0].style.transition = 'opacity 500ms linear';
    div.children[0].style.opacity = '';

    const body = document.getElementById(`wio_container_${props.campaignId}`);
    const acceptButton = body ? body.querySelector('#wioBlockAccept') : null;
    if (acceptButton) {
      acceptButton.onclick = this.acceptBlock;
    }
    return true;
  };

  static insertIframeComponent = (props, gameUrl) => {
    window.addEventListener('message', this.ReceiveMessage(props.campaignId), false);

    const div = document.createElement('div');
    div.id = `WioGameContainer_${props.campaignId}`;

    document.getElementsByTagName('body')[0].append(div);
    render(
      (
        <div
          className="WioGameBG"
          id={`WioGameBG_${props.campaignId}`}
        >
          <div
            className="WioModal"
            onClick={this.refuseBlock(props.campaignId)}
          ><br/>
          </div>
          <div
            className="WioContainer"
            style={{
              opacity: 1,
              zIndex: 1000000001,
            }}
          >
            <iframe
              style={{ opacity: 1 }}
              id={`WioGame_${props.campaignId}`}
              title="WioGame"
              seamless=""
              className="WioFrame"
              src={gameUrl}
              allowFullScreen="true"
              allowTransparency="true"
              scrolling="no"
            />
          </div>
        </div>
      ),
      div,
    );
  };

  static addCSS = (style) => {
    const cssId = 'wioCss';
    if (!document.getElementById(cssId)) {
      const head = document.getElementsByTagName('head')[0];
      const link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = style;
      link.media = 'all';
      head.appendChild(link);
    }
  };

  static refuseBlock = campaignId => (e) => {
    window.WIO.track('refuseBlock', campaignId, Context[campaignId].sessionId);
    if (e) {
      e.stopPropagation();
    }
    document.getElementById(`WioGameBG_${campaignId}`).remove();

    CiblerAPI.refuse(campaignId);
    window.WIO.track('refuseBlock', campaignId );
    let tracking = window.WIO.getCampaignTracking(campaignId);
    if(tracking && tracking.discoverBlock) {
      this.setDailyLock(campaignId)();
    }
    return false;
  };

  static setDailyLock = campaignId => () => {
    localStorage.setItem('ciblerDailyLock', Context.timestamp);
    let campaignLock = [];
    try {
      campaignLock = JSON.parse(localStorage.getItem('ciblerDailyCampaignLock'));
      if (!campaignLock.length) campaignLock = [];
    } catch (e) {
      campaignLock = [];
    }
    campaignLock.push(campaignId);
    localStorage.setItem('ciblerDailyCampaignLock', JSON.stringify(campaignLock));
  };

  static hideBlock = campaignId => () => {
    const element = document.getElementById(`WioGameBG_${campaignId}`);
    if (!element || !element.parentNode) return;
    element.parentNode.removeChild(element);
  };

  static acceptBlock = campaignId => (e, alreadyTracked) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!alreadyTracked) {
      window.WIO.track('acceptBlock', campaignId, Context[campaignId].sessionId);
    }
    if (Context[campaignId].successRateId) window.WIO.track('successClick', Context[campaignId].successRateId);
    const body = document.getElementById(`WioGameBG_${campaignId}`);
    const codeContent = body.querySelector('#ciblerCode') || body.querySelector('#wioBlockCode');

    if (codeContent?.innerText.includes('Code copié')) return false;

    const code = codeContent?.innerText || Context[campaignId].code;
    copy(code);
    const codeBlock = body.querySelector('#wioBlockCode');
    if (codeBlock) {
      codeBlock.value = 'Code copié';
      setTimeout(() => {
        codeBlock.value = Context[campaignId].code;
      }, 2000);
    } else {
      const content = body.querySelector('#ciblerCopy') || body.querySelector('#ciblerCode');
      if (content) {
        const base = content.innerHTML;
        content.innerHTML = '<green>✔&#xfe0e; Code copié</green>';
        setTimeout(() => {
          content.innerHTML = base;
        }, 2000);
      }
    }
    return false;
  };

  static ReceiveMessage = campaignId => (event) => {
    if (event.data === 'closeWioGame') {
      window.WIO.track('click', 'ciblerCloseOperation', true);
      this.hideBlock(campaignId)();
      return;
    }
    if (event.data === 'retryFrameShowed') {
      const now = new Date();
      localStorage.setItem('ciblerDailyLock', `${now.getDate()}${now.getMonth()}${now.getFullYear()}`);
    }
  }

  static customRender = () => false;
}
